import React from 'react';

import { PaymentDto } from '@alpha/payments-dtos';

import HeaderButtons from './HeaderButtons/HeaderButtons';
import HeaderText from './HeaderText/HeaderText';
import useStyles from './styles';

interface IProps {
  selectedPayment?: PaymentDto;
  viewOnly?: boolean,
}

const Header: React.FC<IProps> = ({
  selectedPayment,
  viewOnly,
}: IProps) => {
  const styles = useStyles();

  return (
    <div className={styles.container}>
      <HeaderText
        selectedPayment={selectedPayment}
      />
      {
        !viewOnly
          && (
          <HeaderButtons
            paymentId={selectedPayment?.id || '-'}
          />
          )
      }
    </div>
  );
};

export default Header;
